"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent_1 = __importDefault(require("superagent"));
var exponential_backoff_1 = require("exponential-backoff");
var utils_1 = require("./utils");
var logUploaderMap = new Map();
exports.getOrCreateLogUploader = function (url, debugMode) {
    if (debugMode === void 0) { debugMode = false; }
    var uploader = logUploaderMap.get(url);
    /* if we don't have an uploader for this url, create one */
    if (!uploader) {
        uploader = new LogUploader(url, debugMode);
        logUploaderMap.set(url, uploader);
    }
    return uploader;
};
var LogUploader = /** @class */ (function () {
    function LogUploader(url, debugMode) {
        if (debugMode === void 0) { debugMode = false; }
        this.url = url;
        this.debugMode = debugMode;
        this.hasPendingRequest = false;
        this.sendQueue = [];
    }
    LogUploader.prototype.postLogsToEndpoint = function (requestParams) {
        return __awaiter(this, void 0, void 0, function () {
            var deferred;
            return __generator(this, function (_a) {
                deferred = utils_1.getDeferred();
                this.sendQueue.push({ requestParams: requestParams, deferred: deferred });
                this.sendNextQueuedLogToServer();
                this.debug('adding requestParams to sendQueue', {
                    requestParams: requestParams,
                    updatedSendQueue: this.sendQueue.map(function (i) { return i.requestParams; }),
                    hasPendingRequest: this.hasPendingRequest
                });
                return [2 /*return*/, deferred.promise];
            });
        });
    };
    LogUploader.prototype.postLogsToEndpointInstantly = function (requestParams) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.debug('sending request instantly', { requestParams: requestParams, sendQueue: this.sendQueue.map(function (i) { return i.requestParams; }) });
                return [2 /*return*/, this.sendPostRequest(requestParams)];
            });
        });
    };
    LogUploader.prototype.sendEntireQueue = function () {
        this.debug('sending all queued requests instantly to clear out sendQueue', {
            sendQueue: this.sendQueue.map(function (i) { return i.requestParams; })
        });
        var queueItem;
        /* eslint-disable-next-line no-cond-assign */
        while (queueItem = this.sendQueue.shift()) {
            this.postLogsToEndpoint(queueItem.requestParams);
        }
    };
    LogUploader.prototype.sendNextQueuedLogToServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queueItem;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.hasPendingRequest || this.sendQueue.length === 0) {
                    this.debug('sendNextQueuedLogToServer() but not sending request', {
                        hasPendingRequest: this.hasPendingRequest,
                        sendQueueLength: this.sendQueue.length
                    });
                    return [2 /*return*/];
                }
                queueItem = this.sendQueue.shift();
                queueItem.deferred.promise.finally(function () {
                    _this.debug('queue item completed. removing from queue and resetting send queue', {
                        queueItemRequestParams: queueItem.requestParams, updatedSendQueue: _this.sendQueue.map(function (i) { return i.requestParams; })
                    });
                    /* reset state and send the next item in the queue */
                    _this.hasPendingRequest = false;
                    _this.sendNextQueuedLogToServer();
                });
                this.hasPendingRequest = true;
                this.debug('sending logs to server', { queueItem: queueItem.requestParams, sendQueue: this.sendQueue.map(function (i) { return i.requestParams; }) });
                // return backOff(this.sendPostRequest.bind(this, queueItem.requestParams), {
                return [2 /*return*/, exponential_backoff_1.backOff(function () { return _this.sendPostRequest(queueItem.requestParams); }, {
                        retry: function (err) {
                            return err && err.status === 429;
                        },
                        numOfAttempts: 10,
                        startingDelay: 0,
                        delayFirstAttempt: false,
                        maxDelay: 15000
                    })
                        .then(function (response) {
                        _this.debug('successfully sent logs to server', { requestParams: queueItem.requestParams, response: response });
                        queueItem.deferred.resolve(response);
                    })
                        .catch(function (error) {
                        _this.debug('ERROR sending logs to server', { requestParams: queueItem.requestParams, error: error });
                        return queueItem.deferred.reject(error);
                    })];
            });
        });
    };
    LogUploader.prototype.sendPostRequest = function (requestParams) {
        this.debug('issuing POST request', { requestParams: requestParams });
        return superagent_1.default.post(this.url)
            .set('Authorization', "Bearer " + requestParams.accessToken)
            .type('application/json; charset=UTF-8')
            .send(requestParams);
    };
    LogUploader.prototype.debug = function (message, details) {
        if (this.debugMode) {
            /* tslint:disable-next-line:no-console */
            console.log("%c [DEBUG:log-uploader] " + message, 'color: #32a0a8', utils_1.deepClone(details));
        }
    };
    return LogUploader;
}());
exports.LogUploader = LogUploader;
